module.exports = __webpack_public_path__ + "static/img/offical12.7ae9e81.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/joinus/offical12.jpg
// module id = C9fb
// module chunks = 18